/* global angular, _, findAndReplaceDOMText */

var ngModule = angular.module('trends');

ngModule.service('HighlightShared', ['HistoricContext',
    function(HistoricContext) {
        angular.extend(this, {
            'applyHighlights': function(element) {
                // if no highlights are loaded then attempt to load them from context
                var highlights = HistoricContext.getValue('highlights');
                if (_.isEmpty(highlights)) {
                    // Just return the content if we aren't highlighting
                    return element.get(0).innerHTML;
                }

                var replace_str = '\\b(' + highlights.join('|') + ')\\b';
                var regex = new RegExp(replace_str, 'gi');
                var wrapper_node = $('<span class="highlight"/>')[0];

                var result = element.get(0);
                findAndReplaceDOMText(result, {
                    find: regex,
                    wrap: wrapper_node,
                    preset: 'prose'
                });

                return result.innerHTML;
            },
            'setHighlights': function(highlights) {
                HistoricContext.insert('highlights', highlights, 'session');
            },
        });
    }
]);

// Directive to highlight elements from the 'highlights' historical context.
ngModule.directive('highlight', ['HighlightShared',
    function (HighlightShared) {
        return {
            restrict: 'A',
            scope: true,
            link: function (scope, element) {
                 element.html(HighlightShared.applyHighlights(element));
            }
        };
    }
]).filter('highlight', ['$document', 'HighlightShared',
    function($document, HighlightShared) {
        return function(input) {
            // pseudo hack need to be a proper DOM element to use the find and replace library.
            var node = $('<span/>').append($document[0].createTextNode(input));
            return HighlightShared.applyHighlights(node);
        };
    }
]).run(['$rootScope','HighlightShared', function($rootScope, HighlightShared) {
    // highlights should only exist when coming from search, remove if coming from anywhere else
    $rootScope.$on('$stateChangeSuccess', function(event, to, toParams, from) {
        if (from.name !== 'search' && !from.abstract) {
            HighlightShared.setHighlights(null);
        }
    });
}]);
